import { render, staticRenderFns } from "./SiteHeader.vue?vue&type=template&id=db87e668&scoped=true"
import script from "./SiteHeader.vue?vue&type=script&lang=js"
export * from "./SiteHeader.vue?vue&type=script&lang=js"
import style0 from "./SiteHeader.vue?vue&type=style&index=0&id=db87e668&prod&lang=scss"
import style1 from "./SiteHeader.vue?vue&type=style&index=1&id=db87e668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db87e668",
  null
  
)

export default component.exports